import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CouponEventQueryCriteriaClass extends BaseCriteriaModel {
    hdr_guid?: Optional<string> = Optional.empty();
    txn_type?: Optional<string> = Optional.empty();
    obj_action?: Optional<string> = Optional.empty();
    event_code?: Optional<string> = Optional.empty();
  
    created_after?: Optional<string> = Optional.empty();
    created_before?: Optional<string> = Optional.empty();
    updated_after?: Optional<string> = Optional.empty();
    updated_before?: Optional<string> = Optional.empty();
    created_by_subject_guid?: Optional<string> = Optional.empty();
}

export class CouponEventCriteriaModelQuery {
    query = '';
  
    constructor(couponEventCriteriaModel: CouponEventQueryCriteriaClass) {
      console.log('couponEventCriteriaModel', couponEventCriteriaModel);
  
      if (!couponEventCriteriaModel) {
        return;
      }
  
      this.query += couponEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
      this.query += couponEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
      this.query += couponEventCriteriaModel.obj_action.filter(x => x !== '').map(x => '&obj_action=' + x).orElse('');
      this.query += couponEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
      this.query += couponEventCriteriaModel.created_after.filter(x => x !== '').map(x => '&created_after=' + x).orElse('');
      this.query += couponEventCriteriaModel.created_before.filter(x => x !== null).map(x => '&created_before=' + x).orElse('');
      this.query += couponEventCriteriaModel.updated_after.filter(x => x !== '').map(x => '&updated_after=' + x).orElse('');
      this.query += couponEventCriteriaModel.updated_before.filter(x => x !== null).map(x => '&updated_before=' + x).orElse('');
      this.query += couponEventCriteriaModel.created_by_subject_guid.filter(x => x !== null).map(x => '&created_by_subject_guid=' + x).orElse('');
  
      this.query += '&status=' + couponEventCriteriaModel.status;
      this.query += '&orderBy=' + couponEventCriteriaModel.orderBy;
      this.query += '&order=' + couponEventCriteriaModel.order;
      this.query += '&offset=' + couponEventCriteriaModel.offset + '&limit=' + couponEventCriteriaModel.limit;
    }
  
  }